// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yeI9","top":"styles_top__3lNwZ","left":"styles_left__1rxGX","description":"styles_description__2c3_p"};